import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export default function CTASection({
  title = "Ready to Transform",
  italic = "Your Space?",
  text = "Whether you're looking for custom kitchen cabinets, a complete kitchen or bathroom renovation, or a full home interior transformation, Hive Interior can bring your vision to life.",
}) {
  return (
    <section data-testid="cta-section" className="relative py-28 md:py-40 overflow-hidden grain">
      <img
        src={IMAGES.cta}
        alt="Beautifully renovated kitchen interior in the GTA"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-background/85" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline>Let's Build Together</Overline>
          <h2 className="mt-6 font-heading text-4xl md:text-6xl tracking-tight leading-[1.08] max-w-3xl">
            {title} <span className="italic text-primary">{italic}</span>
          </h2>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-foreground/80 leading-relaxed">
            {text}
          </p>
          <Link
            to="/contact"
            data-testid="cta-consultation-button"
            className="mt-10 inline-flex items-center gap-3 bg-primary text-primary-foreground px-8 py-4 text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300 hover:bg-accent hover:text-accent-foreground group"
          >
            Request a Free Consultation
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
